module.exports = __webpack_public_path__ + "static/media/sails.19647a16.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/sails.png
// module id = 183
// module chunks = 0